import type { HsCameraTool } from './camera-tool.interface';

export class HsCameraLandscape implements HsCameraTool {
  public processControlActions(): void {
    return;
  }
}
